var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"KytMK2Aqzf1sTb93gsDXl"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs'
import { getStoreConfig } from '@config/hooks/useStoreConfig'

const storeConfig = getStoreConfig()

if (storeConfig?.base?.sentry?.enabled) {
    Sentry.init({
        dsn: storeConfig.base.sentry.dsn,
        tracesSampleRate: 1,
        enableLogs: true,
        sendDefaultPii: true
    })
    if (typeof window !== 'undefined') {
        window.Sentry = Sentry
        console.log('Sentry v7 loaded on client')
    }
}
